import z from 'zod';

export const returnRequisitionSchema = z.object({
  comment: z
    .string()
    .min(1, 'This is a required field')
    .max(500, 'Comment exceeds the 500 character limit'),
  returnTo: z.string().optional().nullable(),
});
